import { fetchDictionary } from "./dictionary";

/**
 * Preload all commonly used dictionaries in parallel.
 * Called once after successful authentication in AuthInit.
 * Skips dictionaries already available from localStorage cache.
 * Fire-and-forget — results go to Redux store via fetchDictionary.
 */
export function preloadDictionaries(dispatch, getState) {
  const attrs = [
    "services",
    "offices",
    "companies",
    "countries",
    "fieldsOfWorkCategories",
    "fieldsOfWorks",
    "workTypeMds",
    "languages",
    "qualifications",
    "fieldOfStudyCategories",
    "fieldOfStudies",
    "computerSkillCategories",
    "computerSkills",
    "drivingLicences",
    "tags",
    "spareTimes",
    "partners",
    "employees",
    "cities",
    "counties",
    "referers",
  ];

  const store = getState?.()?.dictionary?.store || {};

  for (const attr of attrs) {
    const cached = store[attr];
    if (cached && Array.isArray(cached) && cached.length > 0) {
      continue; // Already in store from localStorage cache
    }
    fetchDictionary(dispatch, attr);
  }
}
